import React from "react";
import { useEffect, useState } from "react";
import { CustomCard, Title } from "../../Utils/UI/Text";
import EventsBoard from "./EventsBoard";
import NewEvents from "./NewEvents";
import { getEventsByUserLogic } from "../Application/Events.logic";
import Storage from "../../Data/Domain/Storage";

const Events = () => {
  const [localEvents, setLocalEvents] = useState([]);
  const [localCount, setLocalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const userId = new Storage("id").getItem();

  const fetchEvents = async (id) => {
    if (!id) {
      return;
    }

    try {
      setLoading(true);
      const { resources, count } = await getEventsByUserLogic(id);

      console.log("Events fetched:", {
        resourcesCount: resources?.length,
        totalCount: count,
      });

      setLocalEvents(resources || []);
      setLocalCount(count || 0);
    } catch (error) {
      console.error("Error fetching events:", error);
      setLocalEvents([]);
      setLocalCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchEvents(userId);
    }
  }, [userId]);

  const handleEventCreated = () => {
    fetchEvents(userId);
  };

  return (
    <>
      <Title
        children="Events"
        childrenTwo={<NewEvents onEventCreated={handleEventCreated} />}
      />
      <CustomCard>
        <EventsBoard
          events={localEvents}
          totalCountEvents={localCount}
          userId={userId}
          loading={loading}
        />
      </CustomCard>
    </>
  );
};

export default Events;
